import React, { useEffect, useMemo, useState } from 'react';
import * as Styled from './VHSidebar.styled';
import MinimalTab from '../../atoms/MinimalTab/MinimalTab';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectChatSidebarTab,
  ChatSidebarTabs,
  setChatSidebarTab,
} from '../../../slices/chat/ChatSlice';

import {
  actionsSelector,
  actionGroupsSelector,
} from '../../../slices/ActionSlice';
import ActionsList from '../../ActionsList/ActionsList';
import {
  isFullscreenSelector,
  // sidebarTypeVisibleSelector,
} from '../../../slices/vh-player/VHPlayerSlice';
import VHResultsArea from '../../organisms/VHResultsArea/VHResultsArea';
import VHLogsArea from '../VHLogsArea/VHLogsArea';
import VHVitals from '../../vh-types/medical/VHVitals/VHVitals';
import { useFeature } from '../../../../../core/src/components/LaunchDarkly';
import { virtualHumanDataSelector } from '../../../slices/VirtualHumanSlice';
import { useTranslation } from 'react-i18next';

const VHSidebar = () => {
  // const activeTab = useSelector(sidebarTypeVisibleSelector);
  const actionGroupsObjs = useSelector(actionGroupsSelector);
  const actionsObjs = useSelector(actionsSelector);
  const isFullscreen = useSelector(isFullscreenSelector);
  const dispatch = useDispatch();
  const currentTab = useSelector(selectChatSidebarTab);
  const unseenCounts = useSelector((state) => state.chat.unseenCounts);

  const SSVH = useSelector(virtualHumanDataSelector);
  const actions = useSelector(actionsSelector);
  const visibleTabs = useMemo(
    () =>
      Object.values(ChatSidebarTabs).filter((tab) =>
        tab.shouldShow({ SSVH, actions })
      ),
    [SSVH, actions]
  );

  const { t } = useTranslation();

  return (
    <Styled.Wrapper $isFullscreen={isFullscreen}>
      {visibleTabs.length > 1 && (
        <Styled.TabSection>
          {visibleTabs.map((visibleTab) => (
            <MinimalTab
              key={visibleTab.ID}
              active={currentTab.ID === visibleTab.ID}
              title={t(visibleTab.textKey)}
              onClick={() => dispatch(setChatSidebarTab(visibleTab.ID))}
              badgeValue={
                visibleTab.getNotificationNumber
                  ? visibleTab.getNotificationNumber(unseenCounts)
                  : 0
              }
            />
          ))}
        </Styled.TabSection>
      )}

      {currentTab.ID === ChatSidebarTabs.VITALS.ID && <VHVitals />}
      {currentTab.ID === ChatSidebarTabs.CHAT.ID && (
        <VHLogsArea
        //  onSessionComplete={props.onSessionComplete}
        />
      )}
      {currentTab.ID === ChatSidebarTabs.RESULTS.ID && <VHResultsArea />}
      {currentTab.ID === ChatSidebarTabs.ACTIONS.ID && (
        <ActionsList actionGroups={actionGroupsObjs} actions={actionsObjs} />
      )}
      {/* {activeTab.id === VH_SIDEBAR_TABS.VITALS.id && <VHVitals />}
      {activeTab.id === VH_SIDEBAR_TABS.CHAT.id && <VHLogsArea />}
      {activeTab.id === VH_SIDEBAR_TABS.ACTIONS.id && (
        <ActionsList actionGroups={actionGroupsObjs} actions={actionsObjs} />
      )}
      {activeTab.id === VH_SIDEBAR_TABS.RESULTS.id && <VHResultsArea />} */}
    </Styled.Wrapper>
  );
};

VHSidebar.propTypes = {};

export default VHSidebar;
